import service from '@/services/superaccess'
const property = {
  state: {
    support_modal: false
  },
  getters: {
    getStatusSupModal (state) {
      return state.support_modal
    }
  },
  mutations: {
    updatedStatusSupModal (context, status) {
      context.support_modal = status
    }
  },
  actions: {
    createProperty (context, payload) {
      return service.post('/api/properties/create', context, { property: payload })
    },
    getPropertyInfo (context, payload) {
      return service.get('/api/properties', context, { id: payload })
    },
    getCountries (context, payload) {
      return service.get('/api/properties/new', context)
    },
    changeStateServiceProp (context, payload) {
      return service.post('/api/properties/service', context, { id: payload.id, state: payload.state })
    },
    editConfigs (context, payload) {
      return service.post('/api/properties/configs', context, { configs: payload })
    },
    getPlans (context, payload) {
      return service.get('/api/properties/plans', context)
    },
    editPlans (context, payload) {
      return service.post('/api/properties/plans/edit', context, {id: payload.id, shard_name: payload.shard, plan: payload.plan})
    },
    changeStatusSupModal (context, payload) {
      context.commit('updatedStatusSupModal', payload)
    },
    getStateBiometric (context, payload) {
      return service.post('/api/properties/biometric', context, { payload })
    },
    isCondominium (context, payload) {
      return service.post('/api/properties/is-condominium', context, { payload })
    }
  }
}

export default property



// WEBPACK FOOTER //
// app/javascript/src/store/property.js